import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import "./UserList.css";
import logo from "../../Assets/logo.jpg"; // ✅ Import your coin image

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/users/wallet-summary");
        setUsers(res.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || "Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleViewWallet = (userId) => {
    navigate(`/user/${userId}/wallet-history`);
  };

  return (
    <div className="user-list-container">
      <h2>All Users</h2>
      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      {!loading && !error && (
        <table className="user-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Wallet Balance</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No users found
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user._id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.mobile}</td>
 <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={logo}
                        alt="coin"
                        style={{
                          width: "16px",
                          height: "16px",
                          borderRadius: "50%",
                          marginRight: "4px",
                          objectFit: "cover",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
                        }}
                      />
                      {user.wallet}
                    </div>
                  </td>                  <td>
                    <button className="view-wallet-btn" onClick={() => handleViewWallet(user._id)}>
                      View Wallet
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UserList;
